import moment from 'moment';
import { TIME, WEEK_DAYS } from '../constants/DashboardConst';

export const getOrderCountsList = (countList, orderList) => {
  return countList.map((obj) => {
    let count = 0;
    if (obj.status === 'ALL') {
      count = orderList.length;
    } else {
      count = orderList.filter((order) => order.status === obj.status).length;
    }
    return { ...obj, count };
  });
};

export const getOccupancyCounts = (countList, counts, digitalCheckInData) => {
  return countList.map((obj) => {
    let count = 0;
    if (obj.name === 'Current Occupancy') {
      count = counts?.activityStatus?.stayoversRoom ? counts.activityStatus.stayoversRoom : '0';
    } else if (obj.name === 'Digital Check-Ins') {
      count = digitalCheckInData?.digitalCheckIn?.checkInAdoption?.formattedValue
        ? digitalCheckInData?.digitalCheckIn?.checkInAdoption?.formattedValue
        : '0';
    } else if (obj.name === 'Digital Key Activated') {
      count = digitalCheckInData?.digitalCheckIn?.totalKeyGeneration?.formattedValue || 0;
    } else if (obj.name === 'Check-In Today') {
      count = digitalCheckInData?.digitalCheckIn?.checkInAdoption?.formattedValue
        ? digitalCheckInData?.digitalCheckIn?.checkInAdoption?.formattedValue
        : '0';
    }
    return { ...obj, count };
  });
};

export const getOccupancyDetailsCounts = (countList, counts, checkinCounts, todayCount) => {
  return countList.map((obj) => {
    const currentItem = obj.items.map((item) => {
      let count = 0;
      let completedCount = 0;
      let pendingCount = 0;
      switch (item.name) {
        case 'Current Occupancy':
          count = counts?.activityStatus?.stayoversRoom
            ? counts.activityStatus.stayoversRoom
            : '00';
          break;
        case 'Total Accomodation':
          count = counts?.roomSummaryStatus?.totalPhysicalRooms
            ? counts.roomSummaryStatus.totalPhysicalRooms -
              counts.roomSummaryStatus.outofOrder -
              counts.roomSummaryStatus.outofService
            : '00';
          break;
        case 'Occupancy':
          count =
            counts?.roomSummaryStatus?.totalPhysicalRooms && counts?.activityStatus?.stayoversRoom
              ? counts?.activityStatus?.stayoversRoom /
                (counts.roomSummaryStatus.totalPhysicalRooms -
                  counts.roomSummaryStatus.outofOrder -
                  counts.roomSummaryStatus.outofService)
              : 0;
          count = count * 100;
          break;
        case 'Digital Check-Ins':
          count = checkinCounts?.getTotalCheckIn?.selfCheckIns
            ? checkinCounts.getTotalCheckIn.selfCheckIns
            : '0';
          break;
        case 'Digital Key Activated':
          count = checkinCounts?.getTotalCheckIn?.digitalKeysActivated
            ? checkinCounts.getTotalCheckIn.digitalKeysActivated
            : '0';
          break;
        case 'Check-In Today':
          count = todayCount?.checkInTotal ? todayCount.checkInTotal : '0';
          completedCount = todayCount?.checkInCompleted ? todayCount.checkInCompleted : '0';
          pendingCount = todayCount?.checkInPending ? todayCount.checkInPending : '0';
          break;
        case 'Check - Outs':
          count = todayCount?.checkOutTotal ? todayCount.checkOutTotal : '0';
          completedCount = todayCount?.checkOutCompleted ? todayCount.checkOutCompleted : '0';
          pendingCount = todayCount?.checkOutPending ? todayCount.checkOutPending : '0';
          break;
        default:
          break;
      }
      item.completedCount = completedCount;
      item.pendingCount = pendingCount;
      item.count = count;
      return { ...item };
    });
    obj.items = currentItem;
    return { ...obj };
  });
};

export const formatDate = (date, format) => {
  const dateObj = new Date(date);
  return moment(dateObj).format(format);
};

export const formatDateWithInitialFormat = (date, initialFormat, format) => {
  return moment(date, initialFormat).format(format);
};

export const formatTimeSlot = (time, duration) => {
  const startTime = moment(time, ['HH.mm']).format('hh:mm A');
  const endTiem = moment(time, ['HH.mm']).add(Number(duration), 'minute').format('hh:mm A');
  return `${startTime} - ${endTiem}`;
};

export const getTableStatus = (tableReservation, reservationsList, date) => {
  const todayDate = moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD');
  const getCurrentTime = moment().format('HH:mm');
  const currentTime = moment(getCurrentTime, 'HH:mm');
  if (!tableReservation.reservations) return { className: 'vacant-status', status: 'Vacant' };
  const isOccupied = tableReservation?.reservations?.some((timeList) => {
    const getDate = timeList.split('#')[4];
    if (getDate === todayDate) {
      const getBothTime = timeList.split('#')[6];
      const startTime = moment(getBothTime.split('-')[0], 'HH:mm');
      const endTime = moment(getBothTime.split('-')[1], 'HH:mm');
      const isBetween = currentTime.isBetween(startTime, endTime);
      return isBetween;
    }
    return false;
  });
  if (isOccupied) {
    const reservation = reservationsList.find((revList) => {
      return tableReservation?.reservations?.some((timeList) => {
        const getDate = timeList.split('#')[4];
        if (getDate === todayDate) {
          const getBothTime = timeList.split('#')[6];
          const startTime = moment(getBothTime.split('-')[0], 'HH:mm');
          const endTime = moment(getBothTime.split('-')[1], 'HH:mm');
          const isBetween = currentTime.isBetween(startTime, endTime);
          const tableNumber = revList.tableNumbers.some(
            (tn) => tn === tableReservation.tableNumber,
          );
          if (
            isBetween &&
            tableNumber &&
            getBothTime.split('-')[0] === revList.reserveFrom &&
            getBothTime.split('-')[1] === revList.reserveUntil
          )
            return true;
        }
        return false;
      });
    });
    if (isOccupied && !reservation?.isReservedForGuest)
      return { className: 'inactive-status', status: 'Inactive' };
  }
  if (isOccupied) return { className: 'occupied-status', status: 'Occupied' };

  const isReserved = tableReservation?.reservations?.some((timeList) => {
    const getDate = timeList.split('#')[4];
    if (getDate === todayDate) {
      const getBothTime = timeList.split('#')[6];
      const startTime = moment(getBothTime.split('-')[0], 'HH:mm');
      if (currentTime.isBefore(startTime)) return true;
      return false;
    }
  });
  if (isReserved) return { className: 'reserved-status', status: 'Reserved' };
  else return { className: 'vacant-status', status: 'Vacant' };
};

export const getCurrentDayBooking = (tableReservation) => {
  if (!tableReservation) return 0;
  const todayDate = moment().format('YYYY-MM-DD');
  const currentDayBooking = tableReservation.filter((resTime) => {
    const getDate = resTime.split('#')[4];
    if (getDate === todayDate) {
      return true;
    } else {
      return false;
    }
  });
  return currentDayBooking.length;
};

export const getRestaurantTiming = (date, newSelected) => {
  const getCurrentDay = new Date(date).getDay();
  const time = [];
  if (WEEK_DAYS[getCurrentDay]) {
    const isAllDay = newSelected?.hours?.some(
      (hours) =>
        hours?.day === WEEK_DAYS[getCurrentDay].toUpperCase() &&
        (hours?.open === 'all day' || hours?.close === 'all day'),
    );
    if ((newSelected?.hours?.length > 0 && newSelected?.hours[0]?.day === 'EVERYDAY') || isAllDay)
      return TIME;
    const restaurantTiming = newSelected?.hours?.filter(
      (hours) => hours?.day === WEEK_DAYS[getCurrentDay].toUpperCase(),
    );
    if (restaurantTiming?.length === 0) return [];
    restaurantTiming?.forEach((timing) => {
      const getTotalHours = moment(timing?.close, 'HH:mm').diff(
        moment(timing.open, 'HH:mm'),
        'hour',
      );
      let openTiming = timing?.open;
      const hasOpeningTiming = time.find(
        (currTime) => currTime === moment(openTiming, 'HH:mm').format('hh:mm A'),
      );
      if (!hasOpeningTiming) time.push(moment(timing?.open, 'HH:mm').format('hh:mm A'));
      for (let i = 0; i < getTotalHours; i++) {
        openTiming = moment(openTiming, 'HH:mm').add(1, 'hour').format('HH:mm');
        time.push(moment(openTiming, 'HH:mm').format('hh:mm A'));
      }
    });
  }
  return time;
};

export const getTimeElapsed = (stTime) => {
  const nowTime = moment(new Date());
  const startTime = moment(stTime, 'DD/MM/YYYY HH:mm');
  const duration = moment.duration(nowTime.diff(startTime));
  if (duration._isValid && duration._data.milliseconds > 0) {
    let hrs = 0,
      mins = 0;
    if (duration._data.days > 0) {
      hrs += duration._data.days * 24;
    }
    if (duration._data.hours > 0) {
      hrs += duration._data.hours;
    }
    if (duration._data.minutes > 0) {
      mins = duration._data.minutes;
    }
    return hrs ? hrs + ' hrs ' + mins + ' mins' : mins + ' mins';
  } else {
    return '';
  }
};

export const generatedElapsedTime = (startTime, endTime, isSync = false) => {
  const duration = moment.duration(startTime.diff(endTime));
  if (duration._isValid && duration._data.milliseconds > 0) {
    let days = 0,
      hrs = 0,
      mins = 0;
    if (duration._data.days > 0) {
      days += duration._data.days;
    }
    if (duration._data.hours > 0) {
      hrs += duration._data.hours;
    }
    if (duration._data.minutes > 0) {
      mins = duration._data.minutes;
    }

    if (!isSync) {
      if (days !== 0) {
        return `${days} days ${hrs} hrs ${mins} mins`;
      } else if (hrs !== 0) {
        return `${hrs} hrs ${mins} mins`;
      } else {
        return `${mins} mins`;
      }
    } else {
      if (days !== 0) {
        return `${days} days ago`;
      } else if (hrs !== 0) {
        return `${hrs} hrs ago`;
      } else {
        return `${mins} mins ago`;
      }
    }
  } else {
    return '';
  }
};
